import { Reveal, Eyebrow } from "@/components/Reveal";
import { HOW_IT_WORKS_STEPS } from "@/data/content";

export const HowItWorks = () => (
  <section id="how-it-works" data-testid="how-it-works-section" className="py-24 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal className="mx-auto max-w-2xl text-center">
        <Eyebrow className="text-center">A Thoughtful Journey</Eyebrow>
        <h2 className="mt-4 font-serif text-2xl leading-tight tracking-tight text-navy sm:text-3xl lg:text-4xl">
          How Adeya works: from first call to lasting bond
        </h2>
      </Reveal>

      <div className="relative mt-16">
        <div
          aria-hidden="true"
          className="absolute left-0 right-0 top-8 hidden border-t-2 border-dashed border-mauve/30 lg:block"
        />
        <ol className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {HOW_IT_WORKS_STEPS.map((step, i) => (
            <Reveal key={step.step} delay={i * 0.1}>
              <li data-testid={`how-step-${step.step}`} className="relative text-center lg:text-left">
                <div className="relative mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-gold/40 bg-gold-light font-serif text-xl text-gold-dark shadow-ambient lg:mx-0">
                  {step.step}
                </div>
                <h3 className="mt-6 font-serif text-lg text-navy sm:text-xl">{step.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-charcoal/70">{step.desc}</p>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
